import React, { useEffect, useRef } from "react";
import { withRouter } from "react-router";

import styled from "styled-components";

import {checkConnection} from '../../utils/chainUtils';

var Web3 = require('web3');


import TopCardComponent from './CardComponents/TopCardComponent'

import square_cat from '../../assets/square_cat.svg';

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;



const Mobile = styled.div`
  @media only screen and (max-device-width: 480px) {
    padding: 24px;
    width: 100%!important;
  }
`;

const Holder = styled.div`
  @media only screen and (max-device-width: 480px) {
      width: 100%!important;
      margin: 0px!important;
  }
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    /* height: 100vh; */
    height: 100%;
    /* overflow: hidden; */
  }
`;

const PriceMatic = styled.div`
  font-family: 'IBM Plex Mono', monospace;;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #FFFFFF;
`;


const PriceUSD = styled.div`
  font-family: 'IBM Plex Mono', monospace;;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 14px;
  display: flex;
  align-items: center;

  color: #FFFFFF;

  opacity: 0.45;
`;

const Bidder = styled.a`
  font-family: 'IBM Plex Mono', monospace;;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: flex-start;
  text-align: left;

  color: #FFFFFF;
  flex: 1;
  justify-content: center;

`;

const Time = styled.div`
  font-family: 'IBM Plex Mono', monospace;;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: right;

  color: #FFFFFF;

  flex: 1;
  justify-content: flex-end;
`;


const SubTitle = styled.div`
    font-family: 'IBM Plex Mono', monospace;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: right;

    color: #FFFFFF;

    opacity: 0.4;
    margin-top: 16px;
`;

const Link = styled.a`
    font-family: 'IBM Plex Mono', monospace;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: right;

    color: #FFFFFF;

    opacity: 0.4;
    margin-top: 16px;
`;

const Owner = styled.span`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 70px;
`;

// Card to display list and top hero banner for nft items
class Card extends React.Component{
    constructor(props){
        super(props)
        var seconds, ended = false, startTimer, ts;
        if(this.props.item.minted) {
            ts = new Date(this.props.item.mintedAt).getTime()/1000;
            ended = true;
        }
        else {
            ts = new Date(this.props.item.auctionEndingAt).getTime()/1000;
        }
        var now = new Date().getTime()/1000;
        if(!ended && (now < ts))
        {
            seconds = ts - now;
            startTimer = true;
            ended = false
        }
        else {
            seconds = now - ts;
            ended = true
        }
        // seconds = 10 //ts + (15 * 60) - now;
            // startTimer = true;
	// console.log(this.props.bids)
	
	console.log('this.state.ended', ended);
	this.state = {
	    time: {}, seconds: seconds,
	    ended: ended,
	    startTimer: startTimer, bids: this.props.bids,
	    accountConnected:false,
            isOpen:false,
            metaMaskInstallComponentIsOpen:false,
            startWithWithdraw:false,
            startWithDeposit:false
	};
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }
    
    secondsToTime(secs){
        let days = Math.floor(secs / (60 * 60 * 24));
        let hours = Math.floor(secs / (60 * 60));
    
        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);
    
        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);                        
    
        let obj = {
          "d": days,
          "h": hours,
          "m": minutes,
          "s": seconds
        };
        return obj;
      }

    setIsOpen(val){
        this.setState({ isOpen: val })
    }
    
    
    setMetaMaskInstallComponentIsOpen(val){
        this.setState({ metaMaskIsntallComponentIsOpen: val })
    }
    
    async componentDidMount() { 
        let timeLeftVar = this.secondsToTime(this.state.seconds);
          this.setState({ time: timeLeftVar });
          if(this.state.startTimer)
              this.startTimer();
	  let {isConnected, accounts} = await checkConnection();
	  console.log('isConnected', isConnected)
	  this.setState({ accountConnected: isConnected })
	  if(!window.ethereum){
	      return;
	  }
	  window.ethereum.on('accountsChanged',(accounts) => {this.handleAccounts(accounts)});
      }
    
    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
          this.timer = setInterval(this.countDown, 1000);
        }
      }
    
      countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;

        
        // Check if we're at zero.
          if (seconds == 0 || seconds < 0) {
              this.setState({
                  time: this.secondsToTime(0),
                  seconds: 0,
              });
              clearInterval(this.timer);
              //TODO: add stuff to change bid
              this.setState({ended: true})
        }
          else{
              this.setState({
                  time: this.secondsToTime(seconds),
                  seconds: seconds,
              });
          }
      }

    handleAccounts(accounts){
	if(accounts[0]){
	    this.setState({ accountConnected: true });
        }
        else{
	    this.setState({ accountConnected: false });
        }
	
    }
    async connectWithMetamask (){
	if (typeof window.ethereum === 'undefined') {
	    this.props.setMetaMaskInstallComponentIsOpen(true);
	    return
	}
        let ethereum  = window.ethereum;
        let accounts;
        try{
	    accounts = await ethereum.request({ method: 'eth_requestAccounts' });
        }
        catch(e){
	    console.log("error",e)
	    return;
        }
	this.handleAccounts(accounts);
    }
    
    placeBidClicked(){
	this.setIsOpen(true);
    }

    navigateToCreatorProfile(){
	const username = this.props.match.params.username;
	window.open(`/u/${username}`)
    }

    
    
    render(){
        var dropping = false;
        if(!this.props.topcard) {
            return (
                <Mobile>
                    <Holder key={`list-${this.props.index}`} style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        margin: '12px 0px',
                        alignItems: 'center',
                        width: 255,
                        margin: 10,                   
                    }}>
                        <a href={window.location.href.split('?')[0] + '/' +  this.props.item.serial + '?' + (window.location.href.split('?')[1]?window.location.href.split('?')[1]:'')} target='_blank' style={{background: 'rgba(19, 19, 19, 1)', width: '100%', borderRadius: 10}}>
                            <Holder style={{
                                backgroundImage: !dropping ? `linear-gradient(127.32deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 42.82%), url('${this.props.item.imageUri}')`:  `linear-gradient(127.32deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 42.82%), url('${skeleton}')`,
                                width: 255,
                                height: 157,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '100% 100%',
                                borderTopLeftRadius: 10,
                                borderTopRightRadius: 10
                            }}>
                    
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    paddingLeft: 10
                                }}>
                                    { !dropping ? <span style={{
                                        fontSize: 32,
                                        textShadow: '0px 4px 20px rgba(0, 0, 0, 0.4)',
                                        fontWeight: 'bold',
                                        fontFamily: 'Space Mono',
                                    }}>#{this.props.item.serial}</span>
                                    :
                                    <span style={{
                                            fontSize: 32,
                                            textShadow: '0px 4px 20px rgba(0, 0, 0, 0.4)',
                                            fontWeight: 'bold',
                                            fontFamily: 'Space Mono',
                                        }}>#DROPPIN'</span>
                                    }
                        
                                    {false && !dropping && <a href={'glip.gg'} target="_blank" style={{
                                        backgroundColor: '#000',
                                        opacity: 0.75,
                                        padding: '4px 6px'
                                    }}>
                                        <img src={square_cat} />
                                    </a>}
                                </div>
                    
                            </Holder>
                            {!dropping && <div style={{paddingTop: 4, paddingBottom: 4, display: 'flex', justifyContent: 'space-between', width: '100%', backgroundColor: 'rgba(0,0,0,0.3)'}}>
                                <div style={{display: 'flex', justifyContent: 'flex-start', padding: '7.5px 10px', }}>                        
                                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                                        <span style={{fontSize: 10, opacity: 0.4}}>Top Bid</span>
                                        {this.props.item.highestMintBid && <span style={{marginTop: 2, fontSize: 12, fontWeight: 400}}>{this.props.item.highestMintBid} {this.props.item.highestMintBidCurrency}</span>}
                                    </div>
                                    {!this.state.ended ? 
                                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', marginLeft: 20}}>
                                        <span style={{fontSize: 10, opacity: 0.4}}>Ends In</span>
                                        <span style={{marginTop: 2, fontSize: 12, fontWeight: 400}}>{this.state.time.m}m {this.state.time.s}s</span>
                                    </div>
                                    :
                                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', marginLeft: 20}}>
                                        <span style={{fontSize: 10, opacity: 0.4}}>Auction Ended</span>
                                        {this.state.time.d > 0 ? <span style={{marginTop: 2, fontSize: 12, fontWeight: 400}}>{this.state.time.d}d </span> : <span style={{marginTop: 2, fontSize: 12, fontWeight: 400}}>{this.state.time.h}h {this.state.time.m}m {this.state.time.s}s</span>}
                                    </div>
                                    }
                                </div>
                                {!this.state.ended ? 
                                <button      
                                    onClick={() => {
                                        console.log('mfff', window.location.href.split('?')[0])
                                        window.open(
                                            window.location.href.split('?')[0] + '/' +
                                            this.props.item.serial,
                                            '_blank')}} 
                                    style={{padding: '14px 25px', boxShadow: 'none', background: 'linear-gradient(100deg, #001AFF 0%, #DB00FF 100%)', color: '#fff', fontWeight: 600}}>
                                    <span className={'subtitle-button'}>Bid</span>
                                </button>
                                :
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end', paddingRight: 10}}>
                                    <span style={{fontSize: 10, opacity: 0.4}}>owner</span>
                                    <Owner style={{marginTop: 2, fontSize: 12, fontWeight: 400}}>{this.props.item.owner}</Owner>
                                </div>
                                }
                    
                            </div>}  
                        </a>             
                    </Holder>
                </Mobile>
          );
        } else {
   
  
            return (
                <TopCardComponent
                    item={this.props.item}
                    bids={this.props.bids}
                    ended={this.state.ended}
                    username={this.props.match.params.username}
                    perks={this.props.perks}
                >
                </TopCardComponent>
            );
        }
        
    }
  }

export default withRouter(Card);
